import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { homePathForRole } from '../../utils/roleHome';

export default function RequireRole({ allow, children }) {
  const { user } = useAuth();
  const role = user?.role || 'client';
  const allowed = Array.isArray(allow) ? allow : [allow];

  if (!allowed.includes(role)) {
    return <Navigate to={homePathForRole(role)} replace />;
  }

  return children;
}
